import React from 'react';
import './orb-background.css';

// Fixed, full-viewport backdrop matching hootdex.com: pure black base, a deep
// green ambient glow, a faint 60px ledger grid, and a few slow, low-opacity
// "liquid" orbs. Purely decorative: aria-hidden, pointer-events: none, and
// it sits behind all content (z-index -1). Motion is disabled for users who
// prefer reduced motion.
const ORBS = [
  // [top, left, size, colour, morph animation, drift seconds, opacity]
  ['8%', '4%', 220, 'light', 'a', 26, 0.24],
  ['38%', '22%', 220, 'medium', 'b', 34, 0.18],
  ['62%', '78%', 340, 'light', 'a', 40, 0.12],
  ['14%', '72%', 220, 'medium', 'c', 30, 0.15],
  ['80%', '6%', 160, 'light', 'b', 28, 0.14]
];

export default function OrbBackground() {
  return (
    <div className="hd-orb-canvas" aria-hidden="true">
      <div className="hd-orb-ambient" />
      <div className="hd-orb-grid" />
      {ORBS.map(([top, left, size, color, morph, drift, opacity], i) => (
        <div
          key={i}
          className="hd-orb-drift"
          style={{
            top,
            left,
            opacity,
            animationDuration: `${drift}s`,
            animationDelay: `${-i * 5}s`
          }}
        >
          <div
            className={`hd-orb hd-orb-${color} hd-orb-morph-${morph}`}
            style={{ width: size, height: size }}
          >
            <span className="hd-orb-core" />
          </div>
        </div>
      ))}
    </div>
  );
}
